import { Tooltip } from "@mui/material";
import { useState, useEffect } from "react";
import { post } from "../../../redux/ApiHelper";
import { successToast, errorToast } from "../../../utils/toast.util";
import { PayoutInterface } from "../../../interfaces/payout.interface";

interface ReReleaseButtonProps {
  row: PayoutInterface;
}

const ReReleaseButton = ({ row }: ReReleaseButtonProps) => {
  const [lastRelease, setLastRelease] = useState<number>(0);
  const [canRelease, setCanRelease] = useState<boolean>(true);

  useEffect(() => {
    const interval = setInterval(() => {
      const diff = Date.now() - lastRelease;
      setCanRelease(diff >= 5 * 60 * 1000); // 5 min = 300000 ms
    }, 1000); // recheck every second

    return () => clearInterval(interval);
  }, [lastRelease]);

  const handleRelease = async () => {
    try {
      const response = await post(`/admin/payout/request-action`, {
        teacherId: row.teacherId._id,
        payoutId: row._id,
        action: "Accept",
      });
      successToast(
        response.message || "Payment release request sent successfully"
      );
      setLastRelease(Date.now());
    } catch {
      errorToast("Failed to proceed payment. Please try again.");
    }
  };

  return (
    <div>
      {row.adminAction === "Accepted" && row.gatewayStatus !== "COMPLETED" ? (
        <Tooltip
          title={
            canRelease
              ? "Click release to proceed the transaction"
              : "Please wait 5 minutes before retrying"
          }
          placement="top"
        >
          <button
            className={`text-white px-3 py-1 rounded ${
              canRelease
                ? "bg-blue-500 hover:bg-blue-600"
                : "bg-gray-400 cursor-not-allowed"
            }`}
            onClick={async () => {
              if (!canRelease) return;
              const confirm = window.confirm(
                "Are you sure you want to release payment?"
              );
              if (confirm) await handleRelease();
            }}
            disabled={!canRelease}
          >
            Rerelease
          </button>
        </Tooltip>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default ReReleaseButton;
